import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useHookFormMask } from "use-mask-input";
import { Link, useNavigate } from "react-router-dom";

import "./signup.css";
import logo from "../../../assets/logo-login.svg";
import { PHONE_REGEX } from "../../../utils/pagesMapper";
import { createUser } from "../../../services/academetrics";
import ErrorMessage from "../../../components/forms/errorMessage/errorMessage";

const Signup = () => {
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();

  const registerWithMask = useHookFormMask(register);

  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (data) => {
    setIsLoading(true);

    try {
      const response = await createUser({ ...data, role: "Admin" });

      if (response) navigate("/auth/login");
    } catch (err) {
      console.log("Erro:", err);
      alert("Falha ao criar usuário, tente novamente.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="signup-form">
      <div className="logo-form">
        <img src={logo} alt="Academetrics Logo" className="login-logo" />{" "}
      </div>

      <h2>Cadastro</h2>

      <p className="signup-describe">
        Crie agora mesmo sua conta de acesso ao sistema
      </p>

      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "10px"
        }}
      >
        <input
          type="text"
          name="firstName"
          placeholder="Nome"
          {...register("firstName", { required: "O nome é obrigatório." })}
        />
        <ErrorMessage message={errors.firstName?.message} />

        <input
          type="text"
          name="lastName"
          placeholder="Sobrenome"
          {...register("lastName", { required: "O sobrenome é obrigatório." })}
        />
        <ErrorMessage message={errors.lastName?.message} />

        <input
          type="email"
          name="email"
          placeholder="E-mail"
          {...register("email", {
            required: "O e-mail é obrigatório.",
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: "O e-mail é inválido."
            }
          })}
        />
        <ErrorMessage message={errors.email?.message} />

        <input
          type="tel"
          name="phoneNumber"
          placeholder="Celular"
          {...registerWithMask("phoneNumber", ["(99) 99999-9999"], {
            required: "O celular é obrigatório.",
            pattern: {
              value: PHONE_REGEX,
              message: "O telefone é inválido."
            }
          })}
        />
        <ErrorMessage message={errors.phoneNumber?.message} />

        <input
          type="password"
          id="password"
          name="password"
          placeholder="Senha"
          {...register("password", {
            required: "A senha é obrigatória.",
            minLength: {
              value: 6,
              message: "A senha deve ter no mínimo 6 caracteres."
            }
          })}
        />
        <ErrorMessage message={errors.password?.message} />
      </div>

      <button type="submit" disabled={isLoading}>
        {isLoading ? "Carregando..." : "Criar Conta"}
      </button>

      <Link to="/auth/login" className="back-to-login">
        ← Voltar para login
      </Link>
    </form>
  );
};

export default Signup;
